/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-lonely-if */
import { Plan } from '@aibees/shared/definition';
import { useEffect, useState } from 'react';
import { useCurrentSubscriptionApi } from '../../price-and-plan/api/use-current-subscription-api';
import { Provider } from './context';
import { PlanCardContextProps as ContextProps, CreditOptions } from './types';

export const PlanCardProvider = ({
  children,
  plans,
  yearly,
  isPaid,
  config,
  isLoading,
}: ContextProps) => {
  const { data } = useCurrentSubscriptionApi();
  const [currentPlan, setCurrentPlan] = useState<Plan>();
  const [selectedPlan, setSelectedPlan] = useState<Plan>();
  const [options, setOptions] = useState<CreditOptions[]>();

  useEffect(() => {
    if (data && data.current && data.current.plan)
      setCurrentPlan(data.current.plan);
  }, [data]);

  useEffect(() => {
    const items: CreditOptions[] = plans.map((plan) => ({
      id: plan.id || '',
      value: plan.metadata.request || '0',
      isFree: Boolean(plan.metadata.is_free),
    }));
    setOptions(items);

    const currentId = data?.current?.plan?.id;
    const currentRequest = data?.current?.plan?.metadata?.request;

    let matched = plans.find((p) => p.id === currentId);
    if (!matched && currentRequest) {
      matched = plans.find(
        (p) => Number(p.metadata?.request) === Number(currentRequest)
      );
    }

    const fallback = plans.at(0);
    if (matched) {
      setSelectedPlan(matched);
    } else if (fallback) {
      setSelectedPlan(fallback);
    }
  }, [plans, data]);

  const handleSelectPlan = (event: any) => {
    const plan = plans.find((p) => p.id === event.target.value);
    setSelectedPlan(plan);
  };

  return (
    <Provider
      value={{
        yearly,
        isPaid,
        isUsageBased: true,
        handleSelectPlan,
        currentPlan,
        selectedPlan,
        options,
        config,
        isLoading,
      }}
    >
      {children}
    </Provider>
  );
};
